// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferPrice_container__RgXYM","savings":"OfferPrice_savings__GyyT8","price":"OfferPrice_price__GGDrv","currency":"OfferPrice_currency__8saEj"};